import React from 'react';
import { SvgIcon } from './svg-icon';

export const PersonCheck = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M11 12C13.21 12 15 10.21 15 8C15 5.79 13.21 4 11 4C8.79 4 7 5.79 7 8C7 10.21 8.79 12 11 12ZM9 17L12 14.06C11.61 14.02 11.32 14 11 14C8.33 14 3 15.34 3 18V20H12L9 17ZM12 17L15.47 20.5L22 13.91L20.6 12.5L15.47 17.67L13.4 15.59L12 17Z" />
  </SvgIcon>
);
